import React from 'react';

import { numberWithCommas } from 'common/helpers/numberHelper';
import { useLocalization } from 'redux/localization/utils/hooks';

const Totals = (props) => {
  const { currentPage, pageSize, recordCount } = props;
  const { t } = useLocalization();

  let startIndex = 1;
  if (currentPage > 1) {
    startIndex = (currentPage - 1) * pageSize + 1;
  }

  const endIndex = Math.min(startIndex + pageSize - 1, recordCount);

  return (
    <div className="c7-pagination__total">
      {t('general.common.showing')} <span>{numberWithCommas(startIndex)}</span>{' '}
      {t('general.common.to')} <span>{numberWithCommas(endIndex)}</span>{' '}
      {t('general.common.of')} <span>{numberWithCommas(recordCount)}</span>
    </div>
  );
};

export default Totals;
